import React from "react";

// BSU uses Zendesk so this is just a fallback
export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:writing.placement@cei.edu">
                writing.placement@cei.edu
            </a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/cei/siteComponents/helpContent.js